<template>
  <div class="userList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.userList.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.userList.username }}：{{ item.UserName }}</div>
        <div class="list-item">
          {{ $t.userList.createTime }}：{{ item.CreateTime.split(" ")[0] }}
        </div>
        <div class="list-item">
          {{ $t.userList.contactNumber }}：{{ item.PhoneNumber }}
        </div>
        <div class="list-item">{{ $t.userList.email }}：{{ item.Email }}</div>
        <div class="list-item">{{ $t.userList.userState }}：{{ item.IsUseStr }}</div>
        <div class="list-item">{{ $t.userList.roleName }}：{{ item.RoleName }}</div>
        <div class="list-item">
          {{ $t.userList.parentName }}：{{ item.ParentUserName }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.UserId)"
            >{{ $t.meta.view }}</van-button
          >

          <van-button
            :class="item.IsUse == '1' ? 'default-btn' : 'search-btn'"
            size="small"
            type="primary"
            @click="editUserState(item.UserId, item.IsUse == '1' ? 0 : 1)"
          >
            <span v-if="item.IsUse == '1'">{{ $t.userList.freeze }}</span>
            <span v-else>{{ $t.userList.thaw }}</span></van-button
          >

          <van-button
            class="warning-btn"
            size="small"
            type="primary"
            @click="dialogRoleShow(item)"
            >{{ $t.userList.assignRole }}</van-button
          >

          <van-button
            class="search-btn"
            size="small"
            type="primary"
            @click="dialogParentShow(item)"
            >{{ $t.userList.parentName }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="dialogDeleteShow(item.UserId)"
            >{{ $t.meta.delete }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.userList.status }}</div>
        <van-radio-group v-model="isUse" direction="horizontal">
          <van-radio :name="1">{{ $t.userList.option1 }}</van-radio>
          <van-radio :name="2">{{ $t.userList.option2 }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="$t.userList.addUser"
      width="90%"
      v-model="dialogAddVisible"
      @confirm="dialogAddConfirm"
      @cancel="dialogAddCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="userList-alert">
          <van-form ref="registerForm" label-width="80px">
            <van-radio-group
              v-model="registerForm.type"
              @change="resetForm"
              direction="horizontal"
              style="margin-bottom: 10px"
            >
              <van-radio :name="1">{{ $t.userList.phone }}</van-radio>
              <van-radio :name="2">{{ $t.userList.email }}</van-radio>
            </van-radio-group>

            <van-field
              v-model="registerForm.mobile"
              :label="$t.userList.phone"
              :placeholder="$t.meta.input"
              v-if="registerForm.type == 1"
              required
            />

            <van-field
              v-model="registerForm.email"
              :label="$t.userList.email"
              :placeholder="$t.meta.input"
              v-if="registerForm.type == 2"
              required
            />

            <van-field
              v-model="registerForm.password"
              :label="$t.userList.password"
              type="password"
              :placeholder="$t.meta.input"
              required
            />

            <van-field
              v-model="registerForm.code"
              :label="$t.userList.verifyCode"
              label-class="number-label"
              :placeholder="$t.meta.input"
              required
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  @click="sendCode"
                  :disabled="!isShowCode ? true : false"
                >
                  <span v-if="isShowCode">{{ $t.userList.get }}</span>
                  <span v-else>{{ timerNum }}S</span>
                </van-button>
              </template>
            </van-field>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.userList.assignRole"
      width="90%"
      v-model="dialogRoleVisible"
      @confirm="dialogRoleConfirm"
      @cancel="dialogRoleCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="userList-alert">
          <van-field
            clickable
            readonly
            required
            :value="roleForm.name"
            :label="$t.userList.role"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showUserListRole')"
          />
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.userList.parentName"
      width="90%"
      v-model="dialogParentVisible"
      @confirm="dialogParentConfirm"
      @cancel="dialogParentCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="userList-alert">
          <van-field
            clickable
            readonly
            required
            :value="parentForm.name"
            :label="$t.userList.username"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showUserListUser')"
          />
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteUser"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.userList.deleteText }}
      </div>
    </van-dialog>

    <radio-list
      :title="$t.userList.selectRole"
      event="showUserListRole"
      :options="roleList"
      :value="roleForm.id"
      @onSelect="onSelectRole"
    ></radio-list>

    <radio-list
      :title="$t.userList.selectUser"
      event="showUserListUser"
      :options="userList"
      :value="parentForm.id"
      @onSelect="onSelectUser"
    ></radio-list>

    <div class="tool-bar">
      <van-button type="info" block @click="dialogAddShow">{{
        $t.userList.addUser
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
import RadioList from "@components/radioList/RadioList.vue";

Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

import md5 from "js-md5";

export default {
  name: "userList",
  components: {
    RadioList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      CompanyCode: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyCode,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      roleList: [],
      userList: [],
      //filter
      searchText: "",
      isUse: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //添加用户
      dialogAddVisible: false,
      registerForm: {
        type: 1,
        mobile: "",
        email: "",
        password: "",
        code: "",
      },
      //分配角色
      dialogRoleVisible: false,
      roleForm: {
        id: null,
        name: "",
        userId: null,
      },
      //分配上级
      dialogParentVisible: false,
      parentForm: {
        id: null,
        name: "",
        userId: null,
      },
      //删除用户
      dialogDeleteId: "",
      showDeleteDialog: false,
      //倒计时
      isShowCode: true,
      timerNum: 0,
      timerItem: null,
    };
  },
  created() {},
  methods: {
    onSelectRole(value) {
      this.roleForm.id = value;
      var item = this.roleList.find((p) => p.value == value);
      if (item) this.roleForm.name = item.text;
    },
    dialogRoleConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.roleForm.userId,
        RoleId: this.roleForm.id,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .editUserRole(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogRoleCancel() {
      this.dialogRoleVisible = false;
    },
    dialogRoleShow(item) {
      this.roleForm.id = parseInt(item.RoleId);
      this.roleForm.name = item.RoleName;
      this.roleForm.userId = item.UserId;
      this.getRoleList().then((success) => {
        if (success) {
          this.dialogRoleVisible = true;
        }
      });
    },
    onSelectUser(value) {
      this.parentForm.id = value;
      var item = this.userList.find((p) => p.value == value);
      if (item) this.parentForm.name = item.text;
    },
    dialogParentConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.parentForm.userId,
        ParentUserId: this.parentForm.id,
      };
      this.$api.systemManagement
        .setParentRight(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogParentCancel() {
      this.dialogParentVisible = false;
    },
    dialogParentShow(item) {
      if (item.ParentUserId > 0) {
        this.parentForm.id = parseInt(item.ParentUserId);
        this.parentForm.name = item.ParentUserName;
      } else {
        this.parentForm.id = null;
        this.parentForm.name = "";
      }
      this.parentForm.userId = item.UserId;
      this.getUserListByCondition().then((success) => {
        if (success) {
          this.dialogParentVisible = true;
        }
      });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    deleteUser() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.dialogDeleteId,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .deleteUser(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogAddConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.registerForm.type,
        PhoneNumber: this.registerForm.mobile,
        Email: this.registerForm.email,
        Password: md5(this.registerForm.password),
        VerificationCode: this.registerForm.code,
        CompanyCode: this.CompanyCode,
      };
      this.$api.user
        .userRegister(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogAddCancel() {
      this.initData();
      this.dialogAddVisible = false;
    },
    dialogAddShow() {
      this.dialogAddVisible = true;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    initData() {
      this.registerForm.mobile = "";
      this.registerForm.email = "";
      this.registerForm.password = "";
      this.registerForm.code = "";
      this.registerForm.type = 1;
    },
    resetForm() {
      this.registerForm.mobile = "";
      this.registerForm.email = "";
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "userDetail",
        name: "userDetail",
        query: [
          {
            name: "UserId",
            value: id,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.isUse || (this.beginTime && this.endTime)) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.isUse = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    editUserState(id, isUse) {
      this.$commonMethod.showLoading();
      var param = {
        UserId: id,
        IsUse: isUse,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .editUserState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        IsUse: this.isUse,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.systemManagement
        .getUserList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getRoleList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.systemManagement
          .getRoleList({
            PageSize: 100,
            PageIndex: 1,
            CompanyId: this.CompanyId,
          })
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.RoleName,
                value: parseInt(item.RoleId),
              };
              result.push(data);
            });
            this.roleList = result;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getUserListByCondition() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.systemManagement
          .getUserListByCondition({
            CompanyId: this.CompanyId,
            IsUse: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: parseInt(item.UserId),
              };
              result.push(data);
            });
            this.userList = result;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    sendCode() {
      const checkPhone = /^1[3|4|5|8][0-9]\d{4,8}$/;
      const phone = this.registerForm.mobile;
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.registerForm.email;
      if (this.registerForm.type == 1) {
        if (checkPhone.test(phone)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentPhoneNumber,
            type: "danger",
          });
        }
      }
      if (this.registerForm.type == 2) {
        if (checkEmail.test(email)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentEmail,
            type: "danger",
          });
        }
      }
    },
    sendVerificationCode() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.registerForm.type,
        Phone: this.registerForm.mobile,
        Email: this.registerForm.email,
      };
      this.$api.user
        .sendVerificationCode(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.verificationCodeInfo,
            type: "success",
          });
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 120;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.userList {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .userList-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
